import {RawISODateOnlyString, PaginatedResponse} from '@wallaby-ui/core';

import {HaidiSchema} from 'src/js/common/types';

export interface PatientListFilterParams {
  srcId: string;
  fullName: string;
  birthNumber: string;
  organizationIds: number[];
  encounterDateFrom: RawISODateOnlyString;
  encounterDateTo: RawISODateOnlyString;
}

export interface PatientListItem {
  id: string;
  srcId: string;
  fullName: string;
  genderCode: string;
  birthNumber: string;
  birthDate: RawISODateOnlyString;
}

export type PatientList = PaginatedResponse<PatientListItem>;

export enum FilterButtonsCategory {
  Inpatient = 'Inpatient',
  Outpatient = 'Outpatient',
  Laboratory = 'Laboratory',
  HaiType = 'HaiType',
}

export enum HospitalizationBlockEncloser {
  Start = 'Start',
  Middle = 'Middle',
  End = 'End',
}

export interface PatientEventWithFilterData
  extends HaidiSchema.components.schemas.PatientEventDto {
  filterData?: FilterButtonsCategory;
}

export interface PatientEventWithHospitalizationBlock
  extends PatientEventWithFilterData {
  alternateColor?: boolean;
  isHospitalizationBlock?: boolean;
}

export interface PatientDetailEnhancedData
  extends HaidiSchema.components.schemas.PatientDetailDto {
  events: PatientEventWithHospitalizationBlock[];
}
